import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "findbar hidden doorHanger",
  id: "findbar"
}
const _hoisted_2 = {
  id: "secondaryToolbar",
  class: "secondaryToolbar hidden doorHangerRight"
}
const _hoisted_3 = { id: "secondaryToolbarButtonContainer" }
const _hoisted_4 = {
  id: "secondaryPresentationMode",
  class: "secondaryToolbarButton presentationMode visibleLargeView vue-pdf-app-icon presentation-mode",
  title: "Switch to Presentation Mode",
  tabindex: "51",
  "data-l10n-id": "presentation_mode"
}
const _hoisted_5 = {
  id: "secondaryOpenFile",
  class: "secondaryToolbarButton openFile visibleLargeView vue-pdf-app-icon open-file",
  title: "Open File",
  tabindex: "52",
  "data-l10n-id": "open_file"
}
const _hoisted_6 = {
  id: "secondaryPrint",
  class: "secondaryToolbarButton print visibleMediumView vue-pdf-app-icon print-button",
  title: "Print",
  tabindex: "53",
  "data-l10n-id": "print"
}
const _hoisted_7 = {
  href: "#",
  id: "secondaryViewBookmark",
  class: "secondaryToolbarButton bookmark visibleSmallView vue-pdf-app-icon bookmark-button",
  title: "Current view (copy or open in new window)",
  tabindex: "55",
  "data-l10n-id": "bookmark"
}
const _hoisted_8 = {
  id: "secondaryDownload",
  class: "secondaryToolbarButton pdf-download vue-pdf-app-icon download-button pdf-button-toolbar",
  title: "Download",
  tabindex: "54",
  "data-l10n-id": "download"
}
const _hoisted_9 = {
  key: 3,
  class: "horizontalToolbarSeparator visibleLargeView"
}
const _hoisted_10 = {
  id: "firstPage",
  class: "secondaryToolbarButton firstPage vue-pdf-app-icon first-page",
  title: "Go to First Page",
  tabindex: "56",
  "data-l10n-id": "first_page"
}
const _hoisted_11 = {
  id: "lastPage",
  class: "secondaryToolbarButton lastPage vue-pdf-app-icon last-page",
  title: "Go to Last Page",
  tabindex: "57",
  "data-l10n-id": "last_page"
}
const _hoisted_12 = {
  key: 4,
  class: "horizontalToolbarSeparator"
}
const _hoisted_13 = {
  id: "pageRotateCw",
  class: "secondaryToolbarButton rotateCw vue-pdf-app-icon rotate-clockwise",
  title: "Rotate Clockwise",
  tabindex: "58",
  "data-l10n-id": "page_rotate_cw"
}
const _hoisted_14 = {
  id: "pageRotateCcw",
  class: "secondaryToolbarButton rotateCcw vue-pdf-app-icon rotate-counter-clockwise",
  title: "Rotate Counterclockwise",
  tabindex: "59",
  "data-l10n-id": "page_rotate_ccw"
}
const _hoisted_15 = {
  key: 5,
  class: "horizontalToolbarSeparator"
}
const _hoisted_16 = {
  id: "cursorSelectTool",
  class: "secondaryToolbarButton selectTool toggled vue-pdf-app-icon select-tool",
  title: "Enable Text Selection Tool",
  tabindex: "60",
  "data-l10n-id": "cursor_text_select_tool"
}
const _hoisted_17 = {
  id: "cursorHandTool",
  class: "secondaryToolbarButton handTool vue-pdf-app-icon hand-tool",
  title: "Enable Hand Tool",
  tabindex: "61",
  "data-l10n-id": "cursor_hand_tool"
}
const _hoisted_18 = {
  key: 6,
  class: "horizontalToolbarSeparator"
}
const _hoisted_19 = {
  id: "scrollVertical",
  class: "secondaryToolbarButton scrollModeButtons scrollVertical toggled vue-pdf-app-icon scroll-vertical",
  title: "Use Vertical Scrolling",
  tabindex: "62",
  "data-l10n-id": "scroll_vertical"
}
const _hoisted_20 = {
  id: "scrollHorizontal",
  class: "secondaryToolbarButton scrollModeButtons scrollHorizontal vue-pdf-app-icon scroll-horizontal",
  title: "Use Horizontal Scrolling",
  tabindex: "63",
  "data-l10n-id": "scroll_horizontal"
}
const _hoisted_21 = {
  id: "scrollWrapped",
  class: "secondaryToolbarButton scrollModeButtons scrollWrapped vue-pdf-app-icon scroll-wrapped",
  title: "Use Wrapped Scrolling",
  tabindex: "64",
  "data-l10n-id": "scroll_wrapped"
}
const _hoisted_22 = {
  key: 7,
  class: "horizontalToolbarSeparator scrollModeButtons"
}
const _hoisted_23 = {
  id: "spreadNone",
  class: "secondaryToolbarButton spreadModeButtons spreadNone toggled vue-pdf-app-icon spread-none",
  title: "Do not join page spreads",
  tabindex: "65",
  "data-l10n-id": "spread_none"
}
const _hoisted_24 = {
  id: "spreadOdd",
  class: "secondaryToolbarButton spreadModeButtons vue-pdf-app-icon spread-odd",
  title: "Join page spreads starting with odd-numbered pages",
  tabindex: "66",
  "data-l10n-id": "spread_odd"
}
const _hoisted_25 = {
  id: "spreadEven",
  class: "secondaryToolbarButton spreadModeButtons spreadEven vue-pdf-app-icon spread-even",
  title: "Join page spreads starting with even-numbered pages",
  tabindex: "67",
  "data-l10n-id": "spread_even"
}
const _hoisted_26 = {
  key: 8,
  class: "horizontalToolbarSeparator spreadModeButtons"
}
const _hoisted_27 = {
  id: "documentProperties",
  class: "secondaryToolbarButton documentProperties vue-pdf-app-icon document-properties",
  title: "Document Properties…",
  tabindex: "68",
  "data-l10n-id": "document_properties"
}
const _hoisted_28 = { class: "toolbar" }
const _hoisted_29 = { id: "toolbarContainer" }
const _hoisted_30 = { id: "toolbarViewer" }
const _hoisted_31 = { id: "toolbarViewerLeft" }
const _hoisted_32 = {
  id: "sidebarToggle",
  class: "toolbarButton sidebar-toggle pdf-button-toolbar",
  title: "Toggle Sidebar",
  tabindex: "11",
  "data-l10n-id": "toggle_sidebar",
  style: {"margin-left":"0.3rem","margin-right":"0.3rem","height":"auto","width":"auto"}
}
const _hoisted_33 = {
  key: 0,
  class: "splitToolbarButton hiddenSmallView"
}
const _hoisted_34 = {
  id: "viewFind",
  class: "toolbarButton pdf-button-toolbar",
  title: "Find in Document",
  tabindex: "12",
  "data-l10n-id": "findbar"
}
const _hoisted_35 = {
  class: "toolbarButton pageUp page-up pdf-button-toolbar",
  title: "Previous Page",
  id: "previous",
  tabindex: "13",
  "data-l10n-id": "previous"
}
const _hoisted_36 = {
  class: "toolbarButton pageDown page-down pdf-button-toolbar",
  title: "Next Page",
  id: "next",
  tabindex: "14",
  "data-l10n-id": "next"
}
const _hoisted_37 = {
  type: "number",
  id: "pageNumber",
  class: "toolbarField pageNumber",
  title: "Page",
  value: "1",
  size: "4",
  min: "1",
  tabindex: "15",
  "data-l10n-id": "page",
  autocomplete: "off"
}
const _hoisted_38 = {
  id: "numPages",
  class: "toolbarLabel"
}
const _hoisted_39 = { id: "toolbarViewerRight" }
const _hoisted_40 = {
  key: 2,
  class: "verticalToolbarSeparator"
}
const _hoisted_41 = {
  id: "presentationMode",
  class: "toolbarButton presentationMode hiddenMediumView pdf-button-toolbar",
  title: "Switch to Presentation Mode",
  tabindex: "31",
  "data-l10n-id": "presentation_mode"
}
const _hoisted_42 = {
  id: "openFile",
  class: "toolbarButton openFile hiddenLargeView vue-pdf-app-icon open-file",
  title: "Open File",
  tabindex: "32",
  "data-l10n-id": "open_file"
}
const _hoisted_43 = {
  id: "print",
  class: "toolbarButton print hiddenMediumView pdf-button-toolbar",
  title: "Print",
  tabindex: "33",
  "data-l10n-id": "print"
}
const _hoisted_44 = {
  id: "download",
  class: "toolbarButton download hiddenMediumView pdf-button-toolbar",
  title: "Download",
  tabindex: "34",
  "data-l10n-id": "download"
}
const _hoisted_45 = {
  href: "#",
  id: "viewBookmark",
  class: "toolbarButton bookmark hiddenSmallView pdf-button-toolbar",
  title: "Current view (copy or open in new window)",
  tabindex: "36",
  "data-l10n-id": "bookmark"
}
const _hoisted_46 = { id: "toolbarViewerMiddle" }
const _hoisted_47 = { class: "splitToolbarButton" }
const _hoisted_48 = {
  id: "zoomOut",
  class: "toolbarButton zoomOut pdf-button-toolbar",
  title: "Zoom acercar ",
  tabindex: "21",
  "data-l10n-id": "zoom_out"
}
const _hoisted_49 = {
  id: "zoomIn",
  class: "toolbarButton zoomIn pdf-button-toolbar",
  title: "Zoom alejar",
  tabindex: "22",
  "data-l10n-id": "zoom_in"
}
const _hoisted_50 = {
  id: "scaleSelectContainer",
  class: "dropdownToolbarButton vue-pdf-app-icon dropdown-toolbar-button"
}
const _hoisted_51 = {
  id: "scaleSelect",
  title: "Zoom",
  tabindex: "23",
  "data-l10n-id": "zoom"
}
const _hoisted_52 = ["data-l10n-args"]
const _hoisted_53 = ["data-l10n-args"]
const _hoisted_54 = ["data-l10n-args"]
const _hoisted_55 = ["data-l10n-args"]
const _hoisted_56 = ["data-l10n-args"]
const _hoisted_57 = ["data-l10n-args"]
const _hoisted_58 = ["data-l10n-args"]
const _hoisted_59 = ["data-l10n-args"]
const _hoisted_60 = {
  type: "context",
  id: "viewerContextMenu"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_FileSimpleIcon = _resolveComponent("FileSimpleIcon")!
  const _component_AgeticSimpleIcon = _resolveComponent("AgeticSimpleIcon")!
  const _component_AbsibSimpleIcon = _resolveComponent("AbsibSimpleIcon")!
  const _component_BarraIcon = _resolveComponent("BarraIcon")!
  const _component_FileIcon = _resolveComponent("FileIcon")!
  const _component_SearchIcon = _resolveComponent("SearchIcon")!
  const _component_UpIcon = _resolveComponent("UpIcon")!
  const _component_DownIcon = _resolveComponent("DownIcon")!
  const _component_AgeticIcon = _resolveComponent("AgeticIcon")!
  const _component_AbsibIcon = _resolveComponent("AbsibIcon")!
  const _component_FullIScreenIcon = _resolveComponent("FullIScreenIcon")!
  const _component_PrintIcon = _resolveComponent("PrintIcon")!
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")!
  const _component_BookmarkIcon = _resolveComponent("BookmarkIcon")!
  const _component_ZoomInIcon = _resolveComponent("ZoomInIcon")!
  const _component_ZoomOutIcon = _resolveComponent("ZoomOutIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.visible.print)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, {
          key: 0,
          message: 'Preparando para imprimir...'
        }))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_1, _cache[8] || (_cache[8] = [
      _createStaticVNode("<div id=\"findbarInputContainer\"><input id=\"findInput\" class=\"toolbarField\" title=\"Find\" placeholder=\"Buscar\" tabindex=\"91\" data-l10n-id=\"find_input\"><div class=\"splitToolbarButton\"><button id=\"findPrevious\" class=\"toolbarButton findPrevious vue-pdf-app-icon find-previous\" title=\"Find the previous occurrence of the phrase\" tabindex=\"92\" data-l10n-id=\"find_previous\"><span data-l10n-id=\"find_previous_label\">Previous</span></button><div class=\"splitToolbarButtonSeparator\"></div><button id=\"findNext\" class=\"toolbarButton findNext vue-pdf-app-icon find-next\" title=\"Find the next occurrence of the phrase\" tabindex=\"93\" data-l10n-id=\"find_next\"><span data-l10n-id=\"find_next_label\">Next</span></button></div></div><div id=\"findbarOptionsOneContainer\"><input type=\"checkbox\" id=\"findHighlightAll\" class=\"toolbarField\" tabindex=\"94\"><label for=\"findHighlightAll\" class=\"toolbarLabel\" data-l10n-id=\"find_highlight\">Highlight all</label><input type=\"checkbox\" id=\"findMatchCase\" class=\"toolbarField\" tabindex=\"95\"><label for=\"findMatchCase\" class=\"toolbarLabel\" data-l10n-id=\"find_match_case_label\">Match case</label></div><div id=\"findbarOptionsTwoContainer\"><input type=\"checkbox\" id=\"findEntireWord\" class=\"toolbarField\" tabindex=\"96\"><label for=\"findEntireWord\" class=\"toolbarLabel\" data-l10n-id=\"find_entire_word_label\">Whole words</label><span id=\"findResultsCount\" class=\"toolbarLabel hidden\"></span></div><div id=\"findbarMessageContainer\"><span id=\"findMsg\" class=\"toolbarLabel\"></span></div>", 4)
    ]), 512), [
      [_vShow, _ctx.showElem('toolbar.toolbarViewerLeft.findbar', 'findbar')]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "secondary-toolbar-prepend"),
        (_ctx.viewButton.files)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onOpenSidebar('files'))),
              id: "secondaryArchivo",
              class: "secondaryToolbarButton visibleLargeView pdf-button-toolbar-simple",
              title: "Archivos",
              tabindex: "51"
            }, [
              _createVNode(_component_FileSimpleIcon),
              _cache[9] || (_cache[9] = _createElementVNode("span", null, "Archivos", -1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.viewSignature.agetic)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[1] || (_cache[1] = () => _ctx.onOpenSidebar('signatures', 'agetic')),
              id: "secondaryAgetic",
              class: "secondaryToolbarButton visibleLargeView vue-pdf-app-icon",
              title: "Ciudadanía Digital",
              tabindex: "51"
            }, [
              _createVNode(_component_AgeticSimpleIcon),
              _cache[10] || (_cache[10] = _createElementVNode("span", null, "CIUDADANÍA DIGITAL", -1))
            ]))
          : _createCommentVNode("", true),
        (_ctx.viewSignature.adsib)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              onClick: _cache[2] || (_cache[2] = () => _ctx.onOpenSidebar('signatures', 'adsib')),
              id: "secondaryAdsib",
              class: "secondaryToolbarButton visibleLargeView vue-pdf-app-icon",
              title: "ADSIB",
              tabindex: "51"
            }, [
              _createVNode(_component_AbsibSimpleIcon),
              _cache[11] || (_cache[11] = _createElementVNode("span", null, "ADSIB", -1))
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("button", _hoisted_4, _cache[12] || (_cache[12] = [
          _createElementVNode("span", { "data-l10n-id": "presentation_mode_label" }, "Presentation Mode", -1)
        ]), 512), [
          [_vShow, _ctx.showElem('secondaryToolbar.secondaryPresentationMode')]
        ]),
        _withDirectives(_createElementVNode("button", _hoisted_5, _cache[13] || (_cache[13] = [
          _createElementVNode("span", { "data-l10n-id": "open_file_label" }, "Open", -1)
        ]), 512), [
          [_vShow, false]
        ]),
        _withDirectives(_createElementVNode("button", {
          id: "secondaryPrintCustom",
          class: "secondaryToolbarButton print visibleMediumView vue-pdf-app-icon print-button",
          title: "Print",
          tabindex: "53",
          "data-l10n-id": "print",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPrint && _ctx.onPrint(...args)))
        }, _cache[14] || (_cache[14] = [
          _createElementVNode("span", { "data-l10n-id": "print_label" }, "Print", -1)
        ]), 512), [
          [_vShow, _ctx.showElem('secondaryToolbar.secondaryPrint')]
        ]),
        _withDirectives(_createElementVNode("button", _hoisted_6, _cache[15] || (_cache[15] = [
          _createElementVNode("span", { "data-l10n-id": "print_label" }, "Print", -1)
        ]), 512), [
          [_vShow, false]
        ]),
        _withDirectives(_createElementVNode("a", _hoisted_7, _cache[16] || (_cache[16] = [
          _createElementVNode("span", { "data-l10n-id": "bookmark_label" }, "Current View", -1)
        ]), 512), [
          [_vShow, _ctx.showElem('secondaryToolbar.secondaryViewBookmark')]
        ]),
        _withDirectives(_createElementVNode("button", _hoisted_8, _cache[17] || (_cache[17] = [
          _createElementVNode("span", { "data-l10n-id": "download_label" }, "Download", -1)
        ]), 512), [
          [_vShow, true]
        ]),
        (
          _ctx.showElem('secondaryToolbar.secondaryPresentationMode') ||
          _ctx.showElem('secondaryToolbar.secondaryOpenFile') ||
          _ctx.showElem('secondaryToolbar.secondaryPrint') ||
          _ctx.showElem('secondaryToolbar.secondaryDownload') ||
          _ctx.showElem('secondaryToolbar.secondaryViewBookmark')
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_9))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("button", _hoisted_10, _cache[18] || (_cache[18] = [
          _createElementVNode("span", { "data-l10n-id": "first_page_label" }, "Mostrar Primera Página", -1)
        ]), 512), [
          [_vShow, _ctx.showElem('secondaryToolbar.firstPage', 'firstPage')]
        ]),
        _withDirectives(_createElementVNode("button", _hoisted_11, _cache[19] || (_cache[19] = [
          _createElementVNode("span", { "data-l10n-id": "last_page_label" }, "Mostrar Última Página", -1)
        ]), 512), [
          [_vShow, _ctx.showElem('secondaryToolbar.lastPage', 'lastPage')]
        ]),
        (
          _ctx.showElem('secondaryToolbar.lastPage', 'lastPage') ||
          _ctx.showElem('secondaryToolbar.firstPage', 'firstPage')
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_12))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("button", _hoisted_13, _cache[20] || (_cache[20] = [
          _createElementVNode("span", { "data-l10n-id": "page_rotate_cw_label" }, "Rotar hacia la Derecha", -1)
        ]), 512), [
          [_vShow, _ctx.showElem('secondaryToolbar.pageRotateCw', 'pageRotateCw')]
        ]),
        _withDirectives(_createElementVNode("button", _hoisted_14, _cache[21] || (_cache[21] = [
          _createElementVNode("span", { "data-l10n-id": "page_rotate_ccw_label" }, "Rotar hacia la izquierda", -1)
        ]), 512), [
          [_vShow, _ctx.showElem('secondaryToolbar.pageRotateCcw', 'pageRotateCcw')]
        ]),
        (
          _ctx.showElem('secondaryToolbar.pageRotateCcw', 'pageRotateCcw') ||
          _ctx.showElem('secondaryToolbar.pageRotateCw', 'pageRotateCw')
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_15))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("button", _hoisted_16, _cache[22] || (_cache[22] = [
          _createElementVNode("span", { "data-l10n-id": "cursor_text_select_tool_label" }, "SeleccionarTexto", -1)
        ]), 512), [
          [_vShow, 
          _ctx.showElem('secondaryToolbar.cursorSelectTool', 'cursorSelectTool')
        ]
        ]),
        _withDirectives(_createElementVNode("button", _hoisted_17, _cache[23] || (_cache[23] = [
          _createElementVNode("span", { "data-l10n-id": "cursor_hand_tool_label" }, "Vista Panorámica", -1)
        ]), 512), [
          [_vShow, _ctx.showElem('secondaryToolbar.cursorHandTool', 'cursorHandTool')]
        ]),
        (
          _ctx.showElem('secondaryToolbar.cursorHandTool', 'cursorHandTool') ||
          _ctx.showElem('secondaryToolbar.cursorSelectTool', 'cursorSelectTool')
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_18))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("button", _hoisted_19, _cache[24] || (_cache[24] = [
          _createElementVNode("span", { "data-l10n-id": "scroll_vertical_label" }, "Desplazamiento Vertical", -1)
        ]), 512), [
          [_vShow, _ctx.showElem('secondaryToolbar.scrollVertical', 'scrollVertical')]
        ]),
        _withDirectives(_createElementVNode("button", _hoisted_20, _cache[25] || (_cache[25] = [
          _createElementVNode("span", { "data-l10n-id": "scroll_horizontal_label" }, "Desplazamiento Horizontal", -1)
        ]), 512), [
          [_vShow, 
          _ctx.showElem('secondaryToolbar.scrollHorizontal', 'scrollHorizontal')
        ]
        ]),
        _withDirectives(_createElementVNode("button", _hoisted_21, _cache[26] || (_cache[26] = [
          _createElementVNode("span", { "data-l10n-id": "scroll_wrapped_label" }, "Desplazamiento", -1)
        ]), 512), [
          [_vShow, _ctx.showElem('secondaryToolbar.scrollWrapped', 'scrollWrapped')]
        ]),
        (
          _ctx.showElem('secondaryToolbar.scrollWrapped', 'scrollWrapped') ||
          _ctx.showElem('secondaryToolbar.scrollHorizontal', 'scrollHorizontal') ||
          _ctx.showElem('secondaryToolbar.scrollVertical', 'scrollVertical')
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_22))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("button", _hoisted_23, _cache[27] || (_cache[27] = [
          _createElementVNode("span", { "data-l10n-id": "spread_none_label" }, "Vista Ajustada", -1)
        ]), 512), [
          [_vShow, _ctx.showElem('secondaryToolbar.spreadNone', 'spreadNone')]
        ]),
        _withDirectives(_createElementVNode("button", _hoisted_24, _cache[28] || (_cache[28] = [
          _createElementVNode("span", { "data-l10n-id": "spread_odd_label" }, "Vista de una Página", -1)
        ]), 512), [
          [_vShow, _ctx.showElem('secondaryToolbar.spreadOdd', 'spreadOdd')]
        ]),
        _withDirectives(_createElementVNode("button", _hoisted_25, _cache[29] || (_cache[29] = [
          _createElementVNode("span", { "data-l10n-id": "spread_even_label" }, "Vista de dos Páginas", -1)
        ]), 512), [
          [_vShow, _ctx.showElem('secondaryToolbar.spreadEven', 'spreadEven')]
        ]),
        (
          _ctx.showElem('secondaryToolbar.spreadEven', 'spreadEven') ||
          _ctx.showElem('secondaryToolbar.spreadOdd', 'spreadOdd') ||
          _ctx.showElem('secondaryToolbar.spreadNone', 'spreadNone')
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_26))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("button", _hoisted_27, _cache[30] || (_cache[30] = [
          _createElementVNode("span", { "data-l10n-id": "document_properties_label" }, "Información del Documento", -1)
        ]), 512), [
          [_vShow, 
          _ctx.showElem('secondaryToolbar.documentProperties', 'documentProperties')
        ]
        ]),
        _renderSlot(_ctx.$slots, "secondary-toolbar-append")
      ])
    ], 512), [
      [_vShow, _ctx.showElem('secondaryToolbar')]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _renderSlot(_ctx.$slots, "toolbar-left-prepend"),
            _withDirectives(_createElementVNode("button", _hoisted_32, [
              _createVNode(_component_BarraIcon)
            ], 512), [
              [_vShow, _ctx.showElem('sidebar', 'sidebarToggle')]
            ]),
            (_ctx.visible.toolbarViewerLeft)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  (_ctx.viewButton.files)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onOpenSidebar('files'))),
                        class: "toolbarButton sidebar-toggle pdf-button-toolbar",
                        title: "Archivos",
                        tabindex: "12",
                        "data-l10n-id": "toggle_sidebar"
                      }, [
                        _createVNode(_component_FileIcon, {
                          class: _normalizeClass({
                  'pdf-button-selected': _ctx.viewSidebar.files,
                })
                        }, null, 8, ["class"])
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("button", _hoisted_34, [
                    _createVNode(_component_SearchIcon),
                    _cache[31] || (_cache[31] = _createElementVNode("span", { "data-l10n-id": "findbar_label" }, "Find", -1))
                  ], 512), [
                    [_vShow, 
                _ctx.showElem('toolbar.toolbarViewerLeft.findbar', 'toggleFindbar')
              ]
                  ]),
                  _withDirectives(_createElementVNode("button", _hoisted_35, [
                    _createVNode(_component_UpIcon),
                    _cache[32] || (_cache[32] = _createElementVNode("span", { "data-l10n-id": "previous_label" }, "Previous", -1))
                  ], 512), [
                    [_vShow, 
                _ctx.showElem('toolbar.toolbarViewerLeft.previous', 'previousPage')
              ]
                  ]),
                  _withDirectives(_createElementVNode("button", _hoisted_36, [
                    _createVNode(_component_DownIcon),
                    _cache[33] || (_cache[33] = _createElementVNode("span", { "data-l10n-id": "next_label" }, "Next", -1))
                  ], 512), [
                    [_vShow, _ctx.showElem('toolbar.toolbarViewerLeft.next', 'nextPage')]
                  ]),
                  _withDirectives(_createElementVNode("input", _hoisted_37, null, 512), [
                    [_vShow, 
                _ctx.showElem('toolbar.toolbarViewerLeft.pageNumber', 'pageNumber')
              ]
                  ]),
                  _withDirectives(_createElementVNode("span", _hoisted_38, null, 512), [
                    [_vShow, 
                _ctx.showElem('toolbar.toolbarViewerLeft.pageNumber', 'numPages')
              ]
                  ])
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "toolbar-left-append")
          ]),
          _createElementVNode("div", _hoisted_39, [
            _renderSlot(_ctx.$slots, "toolbar-right-prepend"),
            (_ctx.viewSignature.agetic)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onOpenSidebar('signatures', 'agetic'))),
                  class: "toolbarButton agetic hiddenMediumView pdf-button-toolbar",
                  title: "Agetic",
                  tabindex: "35"
                }, [
                  _createVNode(_component_AgeticIcon, {
                    class: _normalizeClass({
                'pdf-button-selected': _ctx.valorLegal.agetic,
              })
                  }, null, 8, ["class"]),
                  _cache[34] || (_cache[34] = _createElementVNode("span", null, "AGETIC", -1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.viewSignature.adsib)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onOpenSidebar('signatures', 'adsib'))),
                  class: "toolbarButton adsib hiddenMediumView pdf-button-toolbar",
                  title: "ADSIB",
                  tabindex: "35"
                }, [
                  _createVNode(_component_AbsibIcon, {
                    class: _normalizeClass({
                'pdf-button-selected': _ctx.valorLegal.adsib,
              })
                  }, null, 8, ["class"]),
                  _cache[35] || (_cache[35] = _createElementVNode("span", null, "ADSIB", -1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.viewSignature.adsib || _ctx.viewSignature.agetic)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("button", _hoisted_41, [
              _createVNode(_component_FullIScreenIcon),
              _cache[36] || (_cache[36] = _createElementVNode("span", { "data-l10n-id": "presentation_mode_label" }, "Presentation Mode", -1))
            ], 512), [
              [_vShow, _ctx.viewButton.presentationMode]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_42, _cache[37] || (_cache[37] = [
              _createElementVNode("span", { "data-l10n-id": "open_file_label" }, "Open", -1)
            ]), 512), [
              [_vShow, _ctx.viewButton.openFile]
            ]),
            _withDirectives(_createElementVNode("button", {
              id: "printCustom",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onPrint && _ctx.onPrint(...args))),
              class: "toolbarButton print hiddenMediumView pdf-button-toolbar",
              title: "Print",
              tabindex: "33",
              "data-l10n-id": "print"
            }, [
              _createVNode(_component_PrintIcon),
              _cache[38] || (_cache[38] = _createElementVNode("span", { "data-l10n-id": "print_label" }, "Print", -1))
            ], 512), [
              [_vShow, _ctx.viewButton.print]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_43, [
              _createVNode(_component_PrintIcon),
              _cache[39] || (_cache[39] = _createElementVNode("span", { "data-l10n-id": "print_label" }, "Print", -1))
            ], 512), [
              [_vShow, false]
            ]),
            _withDirectives(_createElementVNode("button", _hoisted_44, [
              _createVNode(_component_DownloadIcon),
              _cache[40] || (_cache[40] = _createElementVNode("span", { "data-l10n-id": "download_label" }, "Download", -1))
            ], 512), [
              [_vShow, _ctx.viewButton.download]
            ]),
            _withDirectives(_createElementVNode("a", _hoisted_45, [
              _createVNode(_component_BookmarkIcon),
              _cache[41] || (_cache[41] = _createElementVNode("span", { "data-l10n-id": "bookmark_label" }, "Current View", -1))
            ], 512), [
              [_vShow, _ctx.viewButton.viewBookmark]
            ]),
            _cache[42] || (_cache[42] = _createElementVNode("button", {
              id: "secondaryToolbarToggle",
              class: "toolbarButton vue-pdf-app-icon secondary-toolbar-toggle",
              title: "Tools",
              tabindex: "37",
              "data-l10n-id": "tools"
            }, [
              _createElementVNode("span", { "data-l10n-id": "tools_label" }, "Tools")
            ], -1)),
            _renderSlot(_ctx.$slots, "toolbar-right-append")
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_46, [
            _renderSlot(_ctx.$slots, "toolbar-middle-prepend"),
            _createElementVNode("div", _hoisted_47, [
              _withDirectives(_createElementVNode("button", _hoisted_48, [
                _createVNode(_component_ZoomInIcon),
                _cache[43] || (_cache[43] = _createElementVNode("span", { "data-l10n-id": "zoom_out_label" }, "Zoom Out", -1))
              ], 512), [
                [_vShow, 
                _ctx.showElem('toolbar.toolbarViewerMiddle.zoomOut', 'zoomOut')
              ]
              ]),
              _cache[45] || (_cache[45] = _createElementVNode("div", { class: "splitToolbarButtonSeparator" }, null, -1)),
              _withDirectives(_createElementVNode("button", _hoisted_49, [
                _createVNode(_component_ZoomOutIcon),
                _cache[44] || (_cache[44] = _createElementVNode("span", { "data-l10n-id": "zoom_in_label" }, "Zoom In", -1))
              ], 512), [
                [_vShow, _ctx.showElem('toolbar.toolbarViewerMiddle.zoomIn', 'zoomIn')]
              ])
            ]),
            _withDirectives(_createElementVNode("span", _hoisted_50, [
              _createElementVNode("select", _hoisted_51, [
                _cache[46] || (_cache[46] = _createStaticVNode(" &gt; <option id=\"pageAutoOption\" value=\"auto\" data-l10n-id=\"page_scale_auto\"> Automatic Zoom </option><option id=\"pageActualOption\" value=\"page-actual\" data-l10n-id=\"page_scale_actual\"> Actual Size </option><option id=\"pageFitOption\" value=\"page-fit\" data-l10n-id=\"page_scale_fit\"> Page Fit </option><option id=\"pageWidthOption\" value=\"page-width\" data-l10n-id=\"page_scale_width\"> Page Width </option><option id=\"customScaleOption\" value=\"custom\" disabled hidden=\"true\"></option>", 6)),
                _createElementVNode("option", {
                  selected: "",
                  "data-l10n-args": _ctx.getScale(50),
                  value: "0.5",
                  "data-l10n-id": "page_scale_percent"
                }, " 50% ", 8, _hoisted_52),
                _createElementVNode("option", {
                  "data-l10n-args": _ctx.getScale(75),
                  value: "0.75",
                  "data-l10n-id": "page_scale_percent"
                }, " 75% ", 8, _hoisted_53),
                _createElementVNode("option", {
                  "data-l10n-args": _ctx.getScale(100),
                  value: "1",
                  "data-l10n-id": "page_scale_percent"
                }, " 100% ", 8, _hoisted_54),
                _createElementVNode("option", {
                  "data-l10n-args": _ctx.getScale(125),
                  value: "1.25",
                  "data-l10n-id": "page_scale_percent"
                }, " 125% ", 8, _hoisted_55),
                _createElementVNode("option", {
                  "data-l10n-args": _ctx.getScale(150),
                  value: "1.5",
                  "data-l10n-id": "page_scale_percent"
                }, " 150% ", 8, _hoisted_56),
                _createElementVNode("option", {
                  "data-l10n-args": _ctx.getScale(200),
                  value: "2",
                  "data-l10n-id": "page_scale_percent"
                }, " 200% ", 8, _hoisted_57),
                _createElementVNode("option", {
                  "data-l10n-args": _ctx.getScale(300),
                  value: "3",
                  "data-l10n-id": "page_scale_percent"
                }, " 300% ", 8, _hoisted_58),
                _createElementVNode("option", {
                  "data-l10n-args": _ctx.getScale(400),
                  value: "4",
                  "data-l10n-id": "page_scale_percent"
                }, " 400% ", 8, _hoisted_59)
              ])
            ], 512), [
              [_vShow, _ctx.visible.toolbarViewerMiddleZoom]
            ]),
            _renderSlot(_ctx.$slots, "toolbar-middle-append")
          ], 512), [
            [_vShow, _ctx.visible.toolbarViewerMiddle]
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.showElem('toolbar')]
    ]),
    _withDirectives(_createElementVNode("menu", _hoisted_60, _cache[47] || (_cache[47] = [
      _createElementVNode("div", {
        id: "contextFirstPage",
        label: "First Page",
        "data-l10n-id": "first_page"
      }, null, -1),
      _createElementVNode("div", {
        id: "contextLastPage",
        label: "Last Page",
        "data-l10n-id": "last_page"
      }, null, -1),
      _createElementVNode("div", {
        id: "contextPageRotateCw",
        label: "Rotate Clockwise",
        "data-l10n-id": "page_rotate_cw"
      }, null, -1),
      _createElementVNode("div", {
        id: "contextPageRotateCcw",
        label: "Rotate Counter-Clockwise",
        "data-l10n-id": "page_rotate_ccw"
      }, null, -1)
    ]), 512), [
      [_vShow, false]
    ])
  ], 64))
}